import { useState } from 'react'
import { ChevronUpIcon } from '@radix-ui/react-icons'
import { EventGroup } from './types'
import { EventCard } from './EventCard'

interface EventDateGroupProps {
  group: EventGroup
  onPreviewRequest?: (sampleId: number) => void
}

export function EventDateGroup({
  group,
  onPreviewRequest,
}: EventDateGroupProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const hasMoreThan3Events = group.events.length > 3
  const eventsToShow = isExpanded ? group.events : group.events.slice(0, 3)

  return (
    /* Overall container with pistachio background and white border */
    <div className="flex bg-pistachio-200 border border-white rounded-lg">
      {/* Left colored bar and date section */}
      <div className="flex-shrink-0 w-[130px] flex">
        {/* Colored left bar */}
        <div className="w-2 bg-pistachio-100 rounded-l-lg"></div>

        {/* Date container */}
        <div className="flex-1 bg-pistachio-50 p-2">
          <div className="space-y-1">
            <p className="text-xs text-new-company-gray-500 font-inter leading-[1.33]">
              {group.relativeDate}
            </p>
            <p className="text-xs text-new-company-gray-900 font-inter font-medium leading-[1.33]">
              {group.displayDate}
            </p>
          </div>
        </div>
      </div>

      {/* Events Container */}
      <div className="flex-1 p-2 space-y-2">
        {/* Event Cards */}
        {eventsToShow.map((event, idx) => (
          <EventCard
            key={`${event.created_at}-${idx}`}
            event={event}
            onPreviewRequest={onPreviewRequest}
          />
        ))}

        {/* Less/More Button */}
        {hasMoreThan3Events && (
          <div className="flex justify-end">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="flex items-center gap-1 px-3 py-1 text-xs text-green-700 hover:text-green-800 transition-colors"
            >
              <span>
                {isExpanded ? 'Less' : `More (+${group.events.length - 3})`}
              </span>
              <ChevronUpIcon
                className={`w-4 h-4 transition-transform ${
                  isExpanded ? '' : 'rotate-180'
                }`}
              />
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
